var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.23076 10.7692V3.23076H10.7692V10.7692H3.23076ZM4.10576 9.89424H9.89424V4.10576H4.10576V9.89424ZM1.07693 12.9231V14C0.78077 14 0.527239 13.8946 0.316334 13.6837C0.105445 13.4728 0 13.2192 0 12.9231H1.07693ZM0 10.7692V9.69231H1.07693V10.7692H0ZM0 7.53845V6.46155H1.07693V7.53845H0ZM0 4.30769V3.23076H1.07693V4.30769H0ZM1.07693 1.07693H0C0 0.78077 0.105445 0.527239 0.316334 0.316334C0.527239 0.105445 0.78077 0 1.07693 0V1.07693ZM3.23076 14V12.9231H4.30769V14H3.23076ZM3.23076 1.07693V0H4.30769V1.07693H3.23076ZM6.46155 14V12.9231H7.53845V14H6.46155ZM6.46155 1.07693V0H7.53845V1.07693H6.46155ZM9.69231 14V12.9231H10.7692V14H9.69231ZM9.69231 1.07693V0H10.7692V1.07693H9.69231ZM12.9231 14V12.9231H14C14 13.2248 13.8946 13.4798 13.6837 13.6879C13.4728 13.896 13.2192 14 12.9231 14ZM12.9231 10.7692V9.69231H14V10.7692H12.9231ZM12.9231 7.53845V6.46155H14V7.53845H12.9231ZM12.9231 4.30769V3.23076H14V4.30769H12.9231ZM12.9231 1.07693V0C13.2192 0 13.4728 0.105445 13.6837 0.316334C13.8946 0.527239 14 0.78077 14 1.07693H12.9231Z",
    fill: "#747B8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectAll);
export default __webpack_public_path__ + "static/media/select-all.ca2aad9f1b05486801af6e972f4530a1.svg";
export { ForwardRef as ReactComponent };